import lowerFirst from 'lodash/lowerFirst'
import { isFromProfileIndexPage } from '@/components/banners/ProfileMFOBanner/helpers'
import { messages as profileMFOBannerMessages } from '@/components/banners/ProfileMFOBanner/messages'
import type { TFinancingOfferMapper } from '@/components/composed/financing/types'
import {
  CLICKED_ON_SUBMIT_IN_PRE_APPROVAL_POPUP_SESSION_STORAGE_KEY,
  CLICKED_ON_SUBMIT_IN_PRE_APPROVAL_POPUP_SESSION_STORAGE_VALUE,
  CLICKED_ON_SUBMIT_IN_REGION_COVERAGE_MAP_SESSION_STORAGE_KEY,
  CLICKED_ON_SUBMIT_IN_REGION_COVERAGE_MAP_SESSION_STORAGE_VALUE,
} from '@/pages/MFOPage/constants'
import { isNonNullable } from '@/typeguards/common'
import { messages } from './messages'

export const checkAndRemoveUserClickedOnSubmitInRegionCoverageMapFlag = () => {
  try {
    const value = sessionStorage.getItem(CLICKED_ON_SUBMIT_IN_REGION_COVERAGE_MAP_SESSION_STORAGE_KEY)
    sessionStorage.removeItem(CLICKED_ON_SUBMIT_IN_REGION_COVERAGE_MAP_SESSION_STORAGE_KEY)

    return value === CLICKED_ON_SUBMIT_IN_REGION_COVERAGE_MAP_SESSION_STORAGE_VALUE
  } catch {
    return false
  }
}

export const setUserClickedOnSubmitInRegionCoverageMapFlag = () => {
  try {
    sessionStorage.setItem(
      CLICKED_ON_SUBMIT_IN_REGION_COVERAGE_MAP_SESSION_STORAGE_KEY,
      CLICKED_ON_SUBMIT_IN_REGION_COVERAGE_MAP_SESSION_STORAGE_VALUE,
    )
  } catch {
    // just ignore: this is not a critical functionality
  }
}

const hasUserClickedOnSubmitInPreApprovedPopup = () => {
  try {
    const value = sessionStorage.getItem(CLICKED_ON_SUBMIT_IN_PRE_APPROVAL_POPUP_SESSION_STORAGE_KEY)

    return value === CLICKED_ON_SUBMIT_IN_PRE_APPROVAL_POPUP_SESSION_STORAGE_VALUE
  } catch {
    return false
  }
}

export const setUserClickedOnSubmitInPreApprovedPopupFlag = () => {
  try {
    sessionStorage.setItem(
      CLICKED_ON_SUBMIT_IN_PRE_APPROVAL_POPUP_SESSION_STORAGE_KEY,
      CLICKED_ON_SUBMIT_IN_PRE_APPROVAL_POPUP_SESSION_STORAGE_VALUE,
    )
  } catch {
    // just ignore: this is not a critical functionality
  }
}

export const resetUserClickedOnSubmitInPreApprovedPopupFlag = () => {
  try {
    sessionStorage.removeItem(CLICKED_ON_SUBMIT_IN_PRE_APPROVAL_POPUP_SESSION_STORAGE_KEY)
  } catch {
    // just ignore: this is not a critical functionality
  }
}

export const getCommentWithNoteIfUserClickedOnSubmitInPreApprovedPopupMapper =
  (originalComment?: string): TFinancingOfferMapper =>
  body => {
    const commentParts = [originalComment].filter(isNonNullable)

    if (hasUserClickedOnSubmitInPreApprovedPopup()) {
      commentParts.push(messages.request.comment.userClickedOnSubmitInPreApprovedPopup)
    }

    const comment = commentParts.length === 0 ? undefined : commentParts.join(', ')

    return {
      ...body,
      comment,
    }
  }

export const addNotesToCommentForMFOConsulting: TFinancingOfferMapper = body =>
  getCommentWithNoteIfUserClickedOnSubmitInPreApprovedPopupMapper(body.comment)(body)

export const addNotesToCommentForMFOConsultingFromCalculator: TFinancingOfferMapper =
  getCommentWithNoteIfUserClickedOnSubmitInPreApprovedPopupMapper(messages.request.comment.fromCalculator)

export const getAddNotesToCommentForMFOFundingRequestMapper =
  (originalComment?: string): TFinancingOfferMapper =>
  body => {
    const commentParts = [originalComment].filter(isNonNullable)

    if (hasUserClickedOnSubmitInPreApprovedPopup()) {
      commentParts.push(messages.request.comment.userClickedOnSubmitInPreApprovedPopup)
    }

    if (isFromProfileIndexPage()) {
      const part = commentParts.length ? lowerFirst(profileMFOBannerMessages.customComment) : profileMFOBannerMessages.customComment

      commentParts.push(part)
    }

    const comment = commentParts.length === 0 ? undefined : commentParts.join(', ')

    return {
      ...body,
      comment,
    }
  }

export const addNotesToCommentForMFOFundingRequest: TFinancingOfferMapper = body => {
  if (checkAndRemoveUserClickedOnSubmitInRegionCoverageMapFlag()) {
    const modifiedComment = [body.comment, messages.request.comment.fromRegionCoverageMap].filter(Boolean).join(', ')

    return {
      ...body,
      comment: modifiedComment,
    }
  }

  return getAddNotesToCommentForMFOFundingRequestMapper(body.comment)(body)
}
